<template>
  <ul-page fullBody class="course-file" v-loading="loading">
    <template v-slot:left>
      <div class="page-header-right">
        <span class="title">{{
          $t("pages_course_courseFile_171", { var0: archives.studentName })
        }}</span>
      </div>
    </template>
    <template v-slot:right>
      <div class="page-header-right">
        <ul-button type="primary" @click="exportPdf">{{
          $t("pages_course_courseFile_172")
        }}</ul-button>
        <ul-button @click="close">{{
          $t("pages_course_courseFile_173")
        }}</ul-button>
      </div>
    </template>
    <div class="body-content" ref="bodyContent">
      <div class="info">
        <div class="name">
          {{ archives.studentName }}
          <div>{{ $t("pages_course_courseFile_174") }}</div>
        </div>
        <div class="info-ul">
          <ul>
            <li>
              {{
                $t("pages_course_courseFile_175", { var0: archives.studentId })
              }}
            </li>
            <li>
              {{
                $t("pages_course_courseFile_176", {
                  var0:
                    archives.sex == 1
                      ? $t("common_male")
                      : archives.sex == 2
                      ? $t("common_female")
                      : "",
                })
              }}
            </li>
            <li>
              {{
                $t("pages_course_courseFile_177", {
                  var0: archives.registerDate | formatDate,
                })
              }}
            </li>
            <li>
              {{ $t("pages_course_courseFile_178", { var0: archives.mail }) }}
            </li>
            <li>
              {{
                $t("pages_course_courseFile_179", { var0: archives.cellphone })
              }}
            </li>
          </ul>
        </div>
        <div class="info-ul">
          <ul>
            <li
              v-html="
                $t('pages_course_courseFile_textbook', { num: textbookNum })
              "
            ></li>
            <li
              v-html="
                $t('pages_course_courseFile_homework', { num: homeworkNnm })
              "
            ></li>
            <li
              v-html="$t('pages_course_courseFile_exam', { num: examNum })"
            ></li>
            <li
              v-html="
                $t('pages_course_courseFile_discussion', {
                  discussionCount: archives.discussionCount,
                  postCount: archives.postCount,
                })
              "
            ></li>
          </ul>
        </div>
      </div>
      <div>
        <div class="subtitle">{{ $t("pages_course_courseFile_189") }}</div>
        <ul-table :data="archives.textbookList">
          <ul-table-column
            prop="name"
            :label="$t('pages_course_courseFile_151')"
          >
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_152')">
            <template slot-scope="scope">
              <span class="bcc-degree">{{ scope.row.progress }}%</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_153')">
            <template slot-scope="scope">
              {{ scope.row.studyTime | formatSeconds }}
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_154')">
            <template slot-scope="scope">
              {{ scope.row.lastStudyTime | formatDateHH }}
            </template>
          </ul-table-column>
          <ul-table-column
            prop="score"
            :label="$t('pages_course_courseFile_155')"
          >
          </ul-table-column>
        </ul-table>
      </div>
      <div>
        <div class="subtitle">
          {{ $t("pages_course_courseFile_190") }}
          <span>{{
            $t("pages_course_courseFile_191", {
              homeworkNnm: homeworkNnm,
              var1: archives.homeworkList ? archives.homeworkList.length : 0,
            })
          }}</span>
        </div>
        <ul-table :data="archives.homeworkList">
          <ul-table-column :label="$t('pages_course_courseFile_156')">
            <template slot-scope="scope">
              <span :class="{ gray: scope.row.status == 9 }">{{
                scope.row.name
              }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_157')">
            <template slot-scope="scope">
              {{ $t("pages_course_courseFile_192") }}
              <span class="bch-benone">{{
                scope.row.status != 9 && scope.row.status != 0
                  ? "已提交"
                  : "未提交"
              }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_158')">
            <template slot-scope="scope">
              {{
                $t("pages_course_courseFile_194", {
                  var0:
                    scope.row.status != 9 && scope.row.status != 0
                      ? scope.row.score || scoreMpa(scope.row.status)
                      : "--",
                })
              }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div>
        <div class="subtitle">
          {{ $t("pages_course_courseFile_195") }}
          <span>{{
            $t("pages_course_courseFile_196", {
              examNum: examNum,
              var1: archives.examList ? archives.examList.length : 0,
            })
          }}</span>
        </div>
        <ul-table :data="archives.examList">
          <ul-table-column :label="$t('pages_course_courseFile_159')">
            <template slot-scope="scope">
              <span :class="{ gray: scope.row.status == 2 }">{{
                scope.row.name
              }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_160')">
            <template slot-scope="scope">
              {{ $t("pages_course_courseFile_197") }}
              <span class="bch-benone">{{
                scope.row.status == 1 ? $t("course.submittedStatus") : $t("course.unsubmittedStatus")
              }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_161')">
            <template slot-scope="scope">
              {{
                $t("pages_course_courseFile_199", {
                  var0:
                    scope.row.status == 1
                      ? scope.row.score || scope.row.score == 0
                        ? scope.row.score
                        : "--"
                      : "--",
                })
              }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div>
        <div class="subtitle">
          {{ $t("pages_course_courseFile_200") }}
          <span>{{
            $t("pages_course_courseFile_201", {
              classRoomNum: classRoomNum,
              classRoomListActivityNum: classRoomListActivityNum,
            })
          }}</span>
          <span class="view-activitie" @click="viewActivitie">{{
            $t("pages_course_courseFile_202")
          }}</span>
        </div>
        <ul-table :data="archives.classroomList">
          <ul-table-column
            :label="$t('pages_course_courseFile_162')"
            width="400"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_163')">
            <template slot-scope="scope">
              {{ scope.row.joinActivityTimes }}/{{
                scope.row.totalActivityTimes
              }}
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_164')">
            <template slot-scope="scope">
              <span v-if="scope.row.totalAttendanceTimes"
                >{{ scope.row.attendanceTimes }}/{{
                  scope.row.totalAttendanceTimes
                }}</span
              >
              <span v-else>--</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_165')">
            <template slot-scope="scope">
              {{
                $t("pages_course_courseFile_203", {
                  var0:
                    scope.row.score || scope.row.score == 0
                      ? scope.row.score
                      : "--",
                })
              }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
    </div>
    <ul-dialog
      :title="$t('pages_course_courseFile_166')"
      :visible.sync="dialogVisible"
      width="680px"
    >
      <div class="class-room" ref="classRoom">
        <div class="subtitle">
          {{ $t("pages_course_courseFile_204") }}
          <span>{{
            $t("pages_course_courseFile_205", {
              joinRoomNum: joinRoomNum,
              classRoomActivityNum: classRoomActivityNum,
            })
          }}</span>
        </div>
        <ul-table :data="classRoomActivity">
          <ul-table-column :label="$t('pages_course_courseFile_167')">
            <template slot-scope="scope">
              <span>{{ activityType[scope.row.relationType] }}</span>
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_168')">
            <template slot-scope="scope">
              {{ scope.row.totalActivityTimes }}
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_169')">
            <template slot-scope="scope">
              {{ scope.row.joinActivityTimes }}
            </template>
          </ul-table-column>
          <ul-table-column :label="$t('pages_course_courseFile_170')">
            <template slot-scope="scope">
              {{
                $t("pages_course_courseFile_206", {
                  var0: scope.row.score ? scope.row.score : "--",
                })
              }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div slot="footer">
        <ul-button type="primary" @click="exportPdfRoom">{{
          $t("pages_course_courseFile_207")
        }}</ul-button>
      </div>
    </ul-dialog>
  </ul-page>
</template>

<script>
import { archives, archivesClassroom } from "@/api/courseApi";
import { mapGetters } from "vuex";
import { formatDate, formatSeconds } from "@/utils";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
export default {
  name: "courseFile",
  data() {
    return {
      ocId: this.$route.query.ocId,
      stuId: this.$route.query.stuId || null,
      archives: {},
      homeworkNnm: 0,
      examNum: 0,
      textbookNum: 0,
      loading: true,
      dialogVisible: false,
      activityType: {
        9: this.$t("pages_course_courseFile_208"),
        1: this.$t("pages_course_courseFile_209"),
        2: this.$t("pages_course_courseFile_210"),
        4: this.$t("pages_course_courseFile_211"),
        3: this.$t("pages_course_courseFile_212"),
        5: this.$t("pages_course_courseFile_213"),
        14: this.$t("pages_course_courseFile_214"),
        18: this.$t("pages_course_courseFile_215"),
      },
      classRoomActivity: [],
      classRoomActivityNum: 0,
      classRoomListActivityNum: 0,
      joinRoomNum: 0,
      classRoomNum: 0,
    };
  },
  created() {
    let data = {
      studentUserId: this.stuId,
      ocId: this.ocId,
    };
    archives(data).then((res) => {
      this.archives = res.result;
      this.num();
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters({ account: "user/user" }),
  },
  filters: {
    formatDate(date) {
      return formatDate(date, "yyyy-MM-dd");
    },
    formatDateHH(date) {
      return formatDate(date);
    },
    formatSeconds(second) {
      return formatSeconds(second);
    },
  },
  methods: {
    viewActivitie() {
      this.dialogVisible = true;
      archivesClassroom({
        ocId: this.ocId,
        studentUserId: this.stuId,
      }).then((res) => {
        this.classRoomActivityNum = 0;
        this.joinRoomNum = 0;
        this.classRoomActivity = [];
        res.result.forEach((item) => {
          this.classRoomActivityNum =
            this.classRoomActivityNum + item.totalActivityTimes;
          this.joinRoomNum = this.joinRoomNum + item.joinActivityTimes;
          if (item.relationType) {
            this.classRoomActivity.push(item);
          }
        });
      });
    },
    scoreMpa(type) {
      let score = "";
      switch (type) {
        case 0:
          score = this.$t("pages_course_courseFile_216");
          break;
        case 1:
          score = this.$t("pages_course_courseFile_217");
          break;
        case 2:
          score = this.$t("pages_course_courseFile_218");
          break;
        case 3:
          score = this.$t("pages_course_courseFile_219");
          break;
        case 5:
          score = this.$t("pages_course_courseFile_220");
          break;
        case 6:
        case 7:
        case 8:
          score = this.$t("pages_course_courseFile_221");
          break;
        case 10:
          score = this.$t("pages_course_courseFile_222");
          break;
        case 12:
          score = this.$t("pages_course_courseFile_223");
          break;
        default:
          score = 0;
          break;
      }
      return score;
    },
    num() {
      this.homeworkNnm = 0;
      this.examNum = 0;
      this.textbookNum = 0;
      this.classRoomNum = 0;
      this.classRoomListActivityNum = 0;
      this.archives.homeworkList = this.archives.homeworkList || [];
      this.archives.examList = this.archives.examList || [];
      this.archives.textbookList = this.archives.textbookList || [];
      this.archives.homeworkList.forEach((item) => {
        if (item.status != 9 && item.status != 0) {
          this.homeworkNnm++;
        }
      });
      this.archives.examList.forEach((item) => {
        if (item.status == 1) {
          this.examNum++;
        }
      });
      this.archives.classroomList.forEach((item) => {
        this.classRoomNum = this.classRoomNum + item.joinActivityTimes;
        this.classRoomListActivityNum =
          this.classRoomListActivityNum + item.totalActivityTimes;
      });
      this.archives.textbookList.forEach((item) => {
        if (item.studyTime > 0) {
          this.textbookNum++;
        }
      });
    },
    exportPdf() {
      let bodyContent = this.$refs.bodyContent;
      html2canvas(bodyContent).then((canvas) => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 555.28; //595.28//左右边距20
        var imgHeight = (552.28 / contentWidth) * contentHeight; //左右边距20
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        let pdf = new jsPDF("p", "pt");
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 20, 0, imgWidth, imgHeight); //左右边距20
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight); //左右边距20
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(
          this.$t("pages_course_courseFile_224", {
            var0: this.archives.studentName,
          })
        );
      });
    },
    exportPdfRoom() {
      let classRoom = this.$refs.classRoom;
      html2canvas(classRoom).then((canvas) => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 555.28; //595.28//左右边距20
        var imgHeight = (552.28 / contentWidth) * contentHeight; //左右边距20
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        let pdf = new jsPDF("p", "pt");
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight); //左右边距20
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight); //左右边距20
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(
          this.$t("pages_course_courseFile_225", {
            var0: this.archives.studentName,
          })
        );
      });
    },
    close() {
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}
::v-deep.course-file {
  .ul-page__body-content {
    width: 980px !important;
  }
  .body-content {
    margin: 20px auto;
    padding: 20px;
    & > div {
      margin-bottom: 20px;
      border: 1px solid #d1d1d1;
      border-bottom: none;
    }
    .info {
      padding: 20px;
      background: #f3f3f3;
      border: none;
      display: flex;
      .name {
        font-size: 20px;
      }
      .info-ul {
        border-left: 1px solid #d1d1d1;
        ul > li {
          margin-bottom: 15px;
          & > span {
            color: #ff0000;
          }
        }
      }
      & > div {
        padding: 0px 40px;
      }
    }
    .subtitle {
      padding: 10px;
      background: #f3f3f3;
      font-weight: bold;
      span {
        margin-left: 30px;
      }
      .view-activitie {
        cursor: pointer;
        float: right;
        font-weight: normal;
        color: #8d77fb;
      }
    }
  }
}
.class-room {
  border: 1px solid #d1d1d1;
  border-bottom: none;
  .subtitle {
    padding: 10px;
    background: #f3f3f3;
    font-weight: bold;
    span {
      margin-left: 30px;
    }
    .view-activitie {
      cursor: pointer;
      float: right;
      font-weight: normal;
      color: #8d77fb;
    }
  }
}
.bcc-degree {
  color: #0fcf0f;
}
.bch-benone {
  color: #ff6868;
}
.gray {
  color: #969696;
}
</style>